import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/answer/list'
    return request.post(url,data)
}

export function all() {
    let url = '/answer/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/answer/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/answer/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/answer/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/answer/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/answer/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/answer/dmz/options'
    return request.get(url)
}
